<template>
  <div class="user-list">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>单位管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>单位管理</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input size="small"
                  placeholder="请输入"
                  width="264"
                  class="key-word"
                  v-model="keyword"></el-input>
        <span>状态：</span>
        <el-select v-model="value"
                   size="small"
                   class="status">
          <el-option v-for="(item,index) in statusDatas"
                     :key="index"
                     :label="item.status"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary"
                   size="small"
                   @click="handleSearch(keyword,value)"
                   v-if="isCompleted && isShowButton('查询')">查询</el-button>
        <el-button size="small"
                   @click="handleReset"
                   v-if="isCompleted && isShowButton('重置')">重置</el-button>
        <el-button size="small"
                   type="primary"
                   @click="handleOption('新增')"
                   v-if="isCompleted && isShowButton('新增医院')">新增医院</el-button>
      </div>
      <el-table :data="tableData5"
                v-loading="loading"
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left"
                     inline
                     class="demo-table-expand">
              <el-form-item label="医院介绍:">
                <span>{{ props.row.hospitalName }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="医院名称"
                         prop="hospitalName">
        </el-table-column>
        <el-table-column label="地址"
                         prop="hospitalAddr">
        </el-table-column>
        <el-table-column label="联系方式"
                         prop="contactWay">
        </el-table-column>
        <el-table-column label="会议室">
          <template slot-scope="scope">
            <span>{{scope.row.boardroom.join(',')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         width="80"
                         prop="status">
        </el-table-column>
        <el-table-column label="添加时间">
          <template slot-scope="scope">
            <span>{{scope.row.createdTime | date}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="marginRight10"
                       type="text"
                       @click="handleOption('编辑', scope.row)">编辑</el-button>
            <el-popover placement="top"
                        width="172"
                        v-model="scope.row.isAbolish">
              <p><i class="el-icon-error"
                   style="color:red;"></i>该操作不可逆,是否确认？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini"
                           type="text"
                           @click="scope.row.isAbolish = false">取消</el-button>
                <el-button type="primary"
                           size="mini"
                           @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
              </div>
              <el-button class="marginLeft10"
                         slot="reference"
                         type="text">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     @size-change='handleSizeChange'
                     @current-change='handleCurrentChange'
                     :current-page.sync='pageIndex'
                     :page-sizes='[10, 20, 30]'
                     :page-size='pageSize'
                     layout='total, sizes, prev, pager, next, jumper'
                     :total='total'>
      </el-pagination>
    </div>
    <!-- 新增单位 -->
    <el-dialog :title="title"
               @closed="resetRules('ruleForm')"
               :visible.sync="dialogShow"
               :before-close="handleClose">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm">
        <el-row>
          <el-col class="title"
                  :span="3">医院名称：</el-col>
          <el-col :span="21"
                  class="full">
            <el-form-item prop="hospitalName">
              <el-input size="mini"
                        v-model="ruleForm.hospitalName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="title"
                  :span="3">医院地址：</el-col>
          <el-col :span="21"
                  class="full">
            <el-form-item prop="hospitalAddr">
              <el-input size="mini"
                        v-model="ruleForm.hospitalAddr"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="title"
                  :span="3">联系人：</el-col>
          <el-col :span="9">
            <el-form-item prop="contactPerson">
              <el-input size="mini"
                        v-model="ruleForm.contactPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="title"
                  :span="3">联系方式：</el-col>
          <el-col :span="9">
            <el-form-item prop="contactWay">
              <el-input size="mini"
                        v-model="ruleForm.contactWay"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="title"
                  :span="3">医院等级：</el-col>
          <el-col :span="9">
            <el-form-item prop="level">
              <el-select size="mini"
                         v-model="ruleForm.level"
                         placeholder="请选择"
                         @change="handleChangeLevel">
                <el-option v-for="(item,index) in ruleForm.leves"
                           :key="index"
                           :label="item.label"
                           :value="item.level">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="title"
                  :span="3">会议室：</el-col>
          <el-col :span="9">
            <el-form-item>
              <el-select size="mini"
                         v-model="ruleForm.boardroom"
                         multiple
                         placeholder="请选择"
                         @remove-tag="removeTag">
                <el-option v-for="(item,index) in ruleForm.boardrooms"
                           :key="index"
                           :label="item.boardroomName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="title"
                  :span="3">上级医院：</el-col>
          <el-col :span="9">
            <el-form-item prop="superiorID">
              <el-select multiple
                         size="mini"
                         v-model="ruleForm.superiorID"
                         placeholder="请选择上级医院"
                         @change="handleChangeLevel">
                <el-option v-for="(item,index) in superiorHospitalList"
                           :key="index"
                           :label="item.hospitalName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="title"
                  style="margin-left:-29px;"
                  :span="4">社会信用代码：</el-col>
          <el-col :span="8">
            <el-form-item prop="businessOrganizationCode">
              <el-input size="mini"
                        v-model="ruleForm.businessOrganizationCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="title === '编辑医院'">
          <div>
            <el-col class="title"
                    :span="3">状态：</el-col>
            <el-col :span="9">
              <el-form-item prop="level">
                <el-select size="mini"
                           v-model="ruleForm.status"
                           placeholder="请选择">
                  <el-option v-for="(item,index) in ruleForm.statuses"
                             :key="index"
                             :label="item.status"
                             :value="item.status">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  data() {
    var checkPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|19[0-9]|17[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    }
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      pageIndex: 1,   //当前页
      pageSize: 10,  //每页显示数
      totalCache: 0,  //总页数
      isEnable: null,
      title: '',
      keyword: '',
      // 搜索状态
      value: '',
      statusDatas: [{
        status: '正常',
        value: 1
      }, {
        status: '停用',
        value: 2
      }, {
        status: '过期',
        value: 3
      }],
      // 新增单位
      dialogShow: false,
      initForm: {
        hospitalName: '', //医院名称
        hospitalAddr: '',  //医院地址
        contactPerson: '',    //联系人
        contactWay: '',   //联系方式
        level: 1,    //医院等级
        leves: [{
          label: '三级甲',
          level: 1
        }, {
          label: '三级乙',
          level: 2
        }, {
          label: '二级甲',
          level: 3
        }, {
          label: '其他',
          level: 4
        }],
        boardroom: [], //会议室
        boardrooms: [],
        superiorID: [], //上级医院
        createdTime: "",
        status: '',
        statuses: [{
          status: "正常",
        }, {
          status: "停用",
        }],
        businessOrganizationCode: '' // 社会信用代码
      },
      ruleForm: {},
      rules: {
        hospitalName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }, { max: 20, message: '不能超过20个字符串' }],
        hospitalAddr: [{ required: true, message: '请输入单位地址', trigger: 'blur' }, { max: 50, message: '不能超过20个字符串' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }, { max: 10, message: '不能超过10个字符串' }],
        contactWay: [{ validator: checkPhone, trigger: "blur" }],
        level: [{ required: true, message: '请选择医院等级', trigger: 'change' }],
        superiorID: [{ required: false, message: '请选择上级医院', trigger: 'blur' }],
        businessOrganizationCode: [{
          required: true,
          message: '请输入社会信用代码',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            var p = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g
            if (p.test(value)) {
              let val = value.toUpperCase()
              if (value.length === 18) {
                callback()
                return true
              }
            }
            callback(new Error('输入的社会信用代码有误'))
            return false

          }, trigger: 'blur'
        }]
        // boardroom: [{required:true,message:'请选择会议室',trigger:'change'}],
      },
      tableData5: [],
      superiorHospitalList: []
    }
  },
  filters: {
    date(value) {
      value = moment(value).format('YYYY-MM-DD HH:mm')
      return value
    }
  },
  created() {
    this.getBtnRole()
    this.getTableData()
    this.getAllSuperiorHospital()
  },
  computed: {
    total() {
      return this.totalCache
    }
  },
  methods: {
    // 获取所有上级医院
    getAllSuperiorHospital() {
      this.Axios.get('/api/Hospital/GetAllHospital').then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          this.superiorHospitalList = data.data
        } else {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err)
      })
    },
    removeTag(val) {
      this.Axios.get('/api/Hospital/JudgeBRUseInfo?boardroomId=' + val).then(res => {
        if (res.data.flag) {
          this.$message({
            showClose: true,
            message: '会议室正在被使用！不能修改',
            type: 'error'
          });
          this.ruleForm.boardroom.push(val)
        }
      })
    },
    handleClose(done) {
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // 重置
    handleReset() {
      this.keyword = null,
        this.value = null
      this.getTableData()
    },
    // 搜索
    handleSearch(keyword, value) {
      const conditions = {
        pageindex: this.pageIndex,
        pagesize: this.pageSize,
      }
      if (this.value != '') {
        conditions.status = this.value
      }
      if (this.keyword != '') {
        conditions.keyword = this.keyword
      }
      this.loading = true
      this.Axios.get('/api/Hospital/SearchHospitalInfo', {
        params: conditions
      }).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.tableData5 = data.data.ret
          this.totalCache = data.data.total
          this.loading = false
        } else if (data.status == 102) {
          this.tableData5 = []
          this.loading = false
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 添加医院
    addData() {
      let formData = {
        hospitalName: this.ruleForm.hospitalName,
        hospitalAddr: this.ruleForm.hospitalAddr,
        contactWay: this.ruleForm.contactWay,
        contactPerson: this.ruleForm.contactPerson,
        level: this.ruleForm.level,
        boardroom: this.ruleForm.boardroom,
        superiorID: this.ruleForm.superiorID,
        businessOrganizationCode: this.ruleForm.businessOrganizationCode
      }
      this.Axios.post('/api/Hospital/AddHospital', formData)
        .then((res) => {
          if (res.data.status == 100) {
            this.$message({
              showClose: true,
              message: '添加成功!',
              type: 'success'
            });
            this.getTableData()
          } else if (res.data.status == 102) {
            this.$message({
              showClose: true,
              message: '添加失败!',
              type: 'success'
            });
          } else if (res.data.status == 103) {
            this.$message({
              showClose: true,
              message: '添加重复,请重新添加!',
              type: 'success'
            });
          }
        }).catch(function(err) {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        });
      this.$refs['ruleForm'].resetFields()
    },
    // 删除医院
    delData(id) {
      this.Axios.get('/api/Hospital/JudgeHospitalInfo?hospitalId=' + id).then(res => {
        // console.log("删除",res)
        if (res.data.flag === false) {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        } else {
          this.Axios.delete('/api/Hospital/DeleteHospital', {
            params: {
              id: id
            }
          }).then(res => {
            const data = res.data
            // console.log(data)
            if (data.status === 100) {
              this.$message({
                showClose: true,
                message: '删除成功!',
                type: 'success'
              })
              this.getTableData()
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '网络错误，联系管理员',
              type: 'error'
            });
          })
        }
      })
    },
    // 获取表格数据
    getTableData() {
      const conditions = {
        pageindex: this.pageIndex,
        pagesize: this.pageSize,
      }
      this.loading = true
      this.Axios.get('/api/Hospital/SearchHospitalInfo', {
        params: conditions
      }).then(res => {
        const data = res.data
        // console.log('单位管理', data.status)
        if (data.status === 100) {
          this.tableData5 = data.data.ret
          this.totalCache = data.data.total
          this.loading = false
        }
      }).catch(err => {
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 获取新增会议室的数据
    getBoardroom() {
      this.Axios.get('/api/Boardroom/GetAllNewBoardroom')
        .then(res => {
          if (res.data.status === 100) {
            const data = res.data
            // console.log('会议室', data)
            this.initForm.boardrooms = data.data
            this.ruleForm.boardrooms = data.data
          } else {
            this.$message({
              showClose: true,
              message: '没有会议室可用!',
              type: 'error'
            });
            this.initForm.boardrooms = []
            this.ruleForm.boardrooms = []
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    handleChangeLevel() {
      if (this.ruleForm.level == 3) {
        // this.ruleForm.boardroom = []
        // this.ruleForm.boardrooms = []
        this.isEnable = true
      } else {
        this.getBoardroom()
        this.ruleForm.boardrooms = JSON.parse(JSON.stringify(this.initForm.boardrooms))
        this.isEnable = false
      }
    },
    //点击 新增、编辑操作
    handleOption(option, val) {
      this.ruleForm = {}
      if (option === '新增') {
        this.title = '新增医院'
        this.dialogShow = true
        this.getBoardroom()
        this.ruleForm = this.initForm
        this.ruleForm.superiorID = []
      } else if (option === '编辑') {
        this.getBoardroom()
        this.ruleForm.boardroom = []
        this.ruleForm.superiorID = []
        this.title = '编辑医院'
        this.dialogShow = true
        this.Axios.get('/api/Hospital/GetHospitalById?id=' + val.id).then(res => {
          // console.log('编辑信息',res.data.data.boardroom)
          let data = res.data
          let oldBoardroom = data.data.boardroom
          if (data.status == 100) {
            data.data.superiorID == null ? data.data.superiorID = [] : data.data.superiorID = data.data.superiorID
            this.ruleForm = data.data
            // console.log(222, this.ruleForm)
            // debugger
            this.ruleForm.boardroom = []
            this.ruleForm.boardrooms = this.initForm.boardrooms.concat(oldBoardroom)
            for (let item of oldBoardroom) {
              this.ruleForm.boardroom.push(item.id)
            }

            this.ruleForm.leves = this.initForm.leves
            this.ruleForm.statuses = this.initForm.statuses

            if (this.ruleForm.level == 3) {
              this.ruleForm.boardroom = []
              this.isEnable = true
            } else {
              this.isEnable = false
            }
            // console.log('222',this.ruleForm)
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
      }
    },
    // 新增,编辑用户表单
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === '新增医院') {
            // 新增
            this.addData()
            // 获取
            this.getTableData()
            this.dialogShow = false
          } else if (this.title === '编辑医院') {
            // 修改
            if (this.ruleForm.status == '正常') {
              this.ruleForm.status = 1
            } else {
              this.ruleForm.status = 2
            }
            var id = this.ruleForm.id
            let formData = {
              hospitalName: this.ruleForm.hospitalName,
              hospitalAddr: this.ruleForm.hospitalAddr,
              contactWay: this.ruleForm.contactWay,
              contactPerson: this.ruleForm.contactPerson,
              level: this.ruleForm.level,
              boardroom: this.ruleForm.boardroom,
              status: this.ruleForm.status,
              superiorID: this.ruleForm.superiorID,
              businessOrganizationCode: this.ruleForm.businessOrganizationCode
            }
            this.Axios.put('/api/Hospital/UpdateHospital?id=' + id, formData)
              .then((res) => {
                let data = res.data
                if (data.status === 100) {
                  this.$message({
                    showClose: true,
                    message: '修改成功!',
                    type: 'success'
                  })
                  this.getTableData()
                } else {
                  this.$message({
                    showClose: true,
                    message: '修改失败!',
                    type: 'success'
                  })
                }
              })
              .catch(function(err) {
                this.$message({
                  showClose: true,
                  message: '网络错误，联系管理员',
                  type: 'error'
                });
              });

            this.dialogShow = false
          }
        } else {
          // console.log("errorsubmit");
          return false;
        }
      });
    },
    // 删除
    del(id) {
      this.delData(id)
    },
    resetRules(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style scoped lang="less">
.user-list {
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0;
      .marginRight10 {
        margin-right: 10px;
      }
    }
    .el-pagination {
      /deep/ .number,
      /deep/ .btn-prev,
      /deep/ .btn-next {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        width: 32px;
        height: 32px;
      }
    }
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog {
      width: 770px;
    }
    .el-row {
      padding: 15px;
      .title {
        text-align: right;
        padding-top: 10px;
      }
    }
    .full {
      .el-input {
        width: 555px;
      }
    }
    .el-input,
    .el-select {
      width: 206px;
    }
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/SystemSet/UnitsManage.vue